<div class="p-2">
    <div *ngIf="reportCollection.length > 0 && selectedReport">
        <div class="d-flex flex-row flex-wrap gap-1 border border-1 rounded p-2 w-100 border-black">
            <button class="btn-report two-line-clamp" *ngFor="let report of reportCollection" mat-stroked-button
                (click)="selectedReport = report" [ngClass]="report === selectedReport ? 'bg-selected-reporting' : ''" matTooltip="{{report.reportName}}">
                {{report.reportName }} </button>
        </div>
        <div class="d-flex flex-column flex-1 gap-1 border border-1 rounded p-2 border-black">
            <div class="d-flex justify-content-end">
                <button mat-icon-button (click)="removeSelectedReport()">
                    <img src="assets/icons/delete_material.svg" height="24"/>
                </button>
            </div>
            <avs-reporting-visualizer [report]="selectedReport ? selectedReport : null"></avs-reporting-visualizer>
        </div>
    </div> 
    <div *ngIf="reportCollection.length === 0">
        No Reports Available
    </div> 
</div>     

